import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-dark px-4 py-20" data-id="element-67" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-68" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-69" data-mp="9t1lx2h7259f">
          <ShieldCheckIcon className="h-8 w-8 text-brand-coral" aria-hidden="true" data-id="element-70" data-mp="er35doij86lf" />
        </div>
        <h2 className="text-2xl font-black uppercase tracking-tight text-brand-navy md:text-3xl" data-id="element-71" data-mp="jqpuowbmxdal">
          🛡️ Odzyskaj pieniądze albo zatrzymaj pakiet.
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-72" data-mp="sm5ml7stxidj">
          Testuj Gotowi na Siatkówkę bez ryzyka przez 30 dni. Jeśli program nie oszczędzi Ci godzin przygotowań, napisz
          do nas — zwracamy 100% ceny bez zbędnych pytań, a wszystkie bonusy zostają u Ciebie.
        </p>
      </Reveal>
    </section>;
}